module.exports = __webpack_public_path__ + "static/media/icon_walking.e21e09d4.svg";